import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_6c849b9a";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_6c849b9a" };
/** script content **/
require("./picker-modal-base.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Fpicker-modal-base6c849b9a%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fpicker-modal%2Fpicker-modal-base.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_6c849b9a"],
    ctorType: "component",
    outputPath: "components/picker-modal-base6c849b9a/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-modal': getComponent(require("../modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")), 'cube-picker': getComponent(require("../picker/index.mpx?isComponent&outputPath=components%2Findex3b508115%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
